// extracted by mini-css-extract-plugin
export default {"content":"PushLocalesTab_content__rGsIS"};